<script setup lang="ts">
  import { IconEPC, IconCIS } from "@ui-kit";
  import { ScanModal, IncorrectCis, IncorrectEpc, CorrectPair } from "@src/components";

  const { isRfid } = defineProps<{
    isRfid: boolean;
    //"initial" | "error" | "success"
    state: string;
  }>();
  const emit = defineEmits<{
    "close": [value: void];
    "click:ok": [value: void];
    "click:back": [value: void];
  }>();
</script>

<template>
  <div>
    <ScanModal
      v-if="state === 'initial' && isRfid"
      :title="$t('Отсканируйте КИЗ')"
      :subtitle="$t('Проверим, корректна ли связка между ним и EPC меткой')"
      :btnTitle="$t('Отмена')"
      @click:btn="emit('click:back')"
      @click:back="emit('click:back')"
      data-testid="scan-cis"
    >
      <template #icon>
        <IconCIS />
      </template>
      <slot name="pair_write" />
    </ScanModal>
    <ScanModal
      v-else-if="state === 'initial' && !isRfid"
      :title="$t('Отсканируйте EPC метку')"
      :subtitle="$t('Проверим, корректна ли связка между ней и КИЗом')"
      :btnTitle="$t('Отмена')"
      @click:btn="emit('click:back')"
      @click:back="emit('click:back')"
      data-testid="scan-epc"
    >
      <template #icon>
        <IconEPC />
      </template>
      <slot name="pair_write" />
    </ScanModal>
    <CorrectPair v-else-if="state === 'success'" @click:more="emit('click:back')" @click:home="emit('close')" />
    <IncorrectCis v-else-if="isRfid" @click:back="emit('click:back')" @click:btn="emit('click:ok')">
      <slot name="pair_set" />
    </IncorrectCis>
    <IncorrectEpc v-else @click:back="emit('click:back')" @click:btn="emit('click:ok')">
      <slot name="pair_set" />
    </IncorrectEpc>
  </div>
</template>

<style scoped>
  .card-page-short-footer {
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  :deep(.scan-modal__button-ok .button__inner) {
    display: block;
    text-overflow: ellipsis;
    overflow: hidden;
  }
</style>
